<div id="footer-container">
  <small>&copy; Copyright 2021, KlusfixR. All Rights Reserved. Design by <b>Tim van Hal</b></small>
</div>
